import React from 'react'
import './SearchLoader.module.scss'

const SearchLoader = () => (
  <div styleName='lds-ring'>
    <div />
    <div />
    <div />
    <div />
  </div>
)

export default SearchLoader



// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchLoader/SearchLoader.js